// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2480":"92133a4c","4006":"d3def337","5819":"d3def337","8202":"d3def337","8986":"d3def337","9745":"3bd4b3ca","9872":"e0046142"}[chunkId] + ".chunk.css";
};